import { ChevronLeft } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface BackButtonProps {
  onClick: () => void;
  /** Rótulo acessível — descreve o destino. Ex.: "Voltar para Clientes". */
  label?: string;
  className?: string | undefined;
}

// DS: botão voltar — só ícone (32×32). Light define pela borda, dark pela
// superfície (mesma regra dos cards). Sem rótulo visível, então aria-label +
// title são obrigatórios para leitor de tela e afordância no hover.
export function BackButton({ onClick, label = 'Voltar', className }: BackButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      title={label}
      className={cn(
        'inline-flex size-8 shrink-0 items-center justify-center rounded-lg border border-border text-text-2',
        'transition-colors hover:bg-surface2 hover:text-text',
        'dark:border-transparent dark:bg-surface2 dark:hover:bg-surface3',
        className,
      )}
    >
      <ChevronLeft size={16} strokeWidth={1.8} />
    </button>
  );
}
